/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */
import styled from 'styled-components';

import { colors, fonts } from '../../../../theme';

/**
 * @description Style props for panel containers.
 * @interface IStyledProps
 *
 * @property{string} styleProps Style props for current container.
 *
 * @see CollapseWrapper Styled div for render collapse container.
 */
interface IStyledProps {
    styleProps: string;
}

export const CollapseContainerStyled = styled.div.attrs({
    className: 'collapse',
})<IStyledProps>`
    width: 100%;
    animation: fade 1s;
    transition: all 2600ms;
    box-sizing: border-box;
    ${(props) => props.styleProps}
`;

export const CollapseStandardStyled = styled.div`
    width: 794px;
    margin-top: 48px;
    position: relative;

    .collapse__panel-title {
        ${fonts.textMainBold}
    }

    .collapse__panel-body {
        border-bottom: 1px solid ${colors.borderColorLight};
    }

    .collapse__panel-title {
        background: ${colors.backgroundColorWhite};
        padding: 16px 20px;
        border-top: 1px solid ${colors.borderColorLight};
        border-bottom: 1px solid ${colors.borderColorLight};

        &.opened {
            background: ${colors.backgroundColorHoverNormal};
        }
    }

    .loader__frame {
        min-height: 48px;
    }
`;

